/* eslint-disable */
import * as Types from '../../../../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InProductMessagesQueryVariables = Types.Exact<{
  input: Types.InProductMessagesInput;
}>;

export type InProductMessagesQuery = {
  __typename?: 'Query';
  inProductMessages: {
    __typename?: 'InProductMessagesList';
    totalCount: number;
    items: Array<{
      __typename?: 'InProductMessage';
      content: string;
      sentAt: any;
      id: string;
      isRead: boolean;
      campaignName: string;
    }>;
    cursorInfo: {
      __typename?: 'InProductMessagesCursorInfo';
      lastMessageId?: string | null;
    };
  };
};

export const InProductMessagesDocument = gql`
  query inProductMessages($input: InProductMessagesInput!) {
    inProductMessages(input: $input) {
      items {
        content
        sentAt
        id
        isRead
        campaignName
      }
      cursorInfo {
        lastMessageId
      }
      totalCount
    }
  }
`;

/**
 * __useInProductMessagesQuery__
 *
 * To run a query within a React component, call `useInProductMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInProductMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInProductMessagesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInProductMessagesQuery(
  baseOptions: Apollo.QueryHookOptions<
    InProductMessagesQuery,
    InProductMessagesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    InProductMessagesQuery,
    InProductMessagesQueryVariables
  >(InProductMessagesDocument, options);
}
export function useInProductMessagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InProductMessagesQuery,
    InProductMessagesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    InProductMessagesQuery,
    InProductMessagesQueryVariables
  >(InProductMessagesDocument, options);
}
export type InProductMessagesQueryHookResult = ReturnType<
  typeof useInProductMessagesQuery
>;
export type InProductMessagesLazyQueryHookResult = ReturnType<
  typeof useInProductMessagesLazyQuery
>;
export type InProductMessagesQueryResult = Apollo.QueryResult<
  InProductMessagesQuery,
  InProductMessagesQueryVariables
>;
